import React from 'react';
import { LocaleContext } from '../../../contexts/language';
import { createIntl } from 'react-intl';
import { BrandContext } from '../../../contexts/branding';
import IconButton from '@mui/material/IconButton';
import ShareIcon from '@mui/icons-material/Share';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import { EmailShareButton, FacebookShareButton, WhatsappShareButton } from 'react-share';
import { SocialIcon } from 'react-social-icons';
import PropTypes from 'prop-types';
import ar from './ar.json';
import en from './en.json';

const languages = {
  ar,
  en
};

export const ShareItemButton = ( { url, make, model } ) => {
  const { lang } = React.useContext(LocaleContext);
  const intl = createIntl({ locale: lang || 'en', messages: languages[lang] || languages.en });
  const brand = React.useContext(BrandContext);
  const companyName = brand.layout.footer.copyright.brandTitle[lang] || brand.layout.footer.copyright.brandTitle.en;

  const [showDialog, setShowDialog] = React.useState(false);

  return (
    <>
      <IconButton aria-label="share"  sx={{ border:'1px solid' }} onClick={() => setShowDialog(true)}>
        <ShareIcon/>
      </IconButton>

      <Dialog
        PaperProps={{
          style: {
            backgroundColor: 'white',
            // boxShadow: 'none',
          },
        }}
        onClose={() => setShowDialog(false)} open={showDialog}>
        <DialogTitle>{
          intl.formatMessage({
            id: 'shareModel.title',
            defaultMessage: 'Share this {make} {model}'
          }, { make, model })
        }</DialogTitle>
        <DialogContent>
          <Stack spacing={2} direction={'row'}>
            <EmailShareButton
              size={24}
              url={typeof window !=='undefined' ? `${window?.location?.origin}${url}` : undefined}
              subject={
                intl.formatMessage({
                  id: 'shareModel.email.subject',
                  defaultMessage: 'View this {make} {model} on {companyName}'
                }, { make, model, companyName })
              }
              body={
                intl.formatMessage({
                  id: 'shareModel.email.body',
                  defaultMessage: 'Tell me what you think about this on {companyName}'
                }, { make, model, companyName })
              }
            >
              <SocialIcon network="email"/>
            </EmailShareButton>
            <FacebookShareButton
              url={typeof window !=='undefined' ? `${window?.location?.origin}${url}` : undefined}
            >
              <SocialIcon network="facebook"/>
            </FacebookShareButton>
            <WhatsappShareButton
              url={typeof window !=='undefined' ? `${window?.location?.origin}${url}` : undefined}

              title={
                intl.formatMessage({
                  id: 'shareModel.whatsapp.title',
                  defaultMessage: 'Tell me what you think about this {make} {model} on {companyName}'
                }, { make, model, companyName })
              }
            >
              <SocialIcon network="whatsapp"/>
            </WhatsappShareButton>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ShareItemButton;

ShareItemButton.propTypes = {
  url:PropTypes.string.isRequired,
  make:PropTypes.string.isRequired,
  model:PropTypes.string.isRequired,
};